import clsx from "clsx";
import React from "react";

const ProgressBar = ({ maxAmount, currentAmount, progressBarClassName, trackClassName }: any) => {
  const percentage = !maxAmount ? 0 : Math.min((currentAmount / maxAmount) * 100, 100);

  return (
    <div className={clsx("relative h-1 w-full rounded-full", trackClassName ?? "bg-black")}>
      <div className={clsx("h-1 bg-green rounded-full", progressBarClassName)} style={{ width: percentage + "%" }} />
    </div>
  );
};

export default ProgressBar;
